import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IAuthenticate } from 'src/app/models/auth/interfaces/authenticate.interface';
import { AppsSettings } from 'src/app/models/settings/app-settings';
import { DomainSettings } from 'src/app/models/settings/domain-settings';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
    selector: 'app-banner-settings-menu',
    templateUrl: './banner-settings-menu.component.html',
    styleUrls: ['./banner-settings-menu.component.scss'],
    imports: [MatMenuModule, MatIconModule, MatTooltipModule],
})
export class MenuSettingsComponent implements OnInit, OnDestroy {
    /**
     * Utilisé pour gérer la désincription des observables lorsque le composant est détruit.
     */
    protected componentDestroyed$: Subject<void> = new Subject<void>();

    @Input()
    public userConnected: IAuthenticate;

    public domainSettings: DomainSettings;
    public cesarApplications: AppsSettings[] = [];

    // Constructeur
    constructor(public settingsService: SettingsService) {}

    ngOnInit(): void {
        this.settingsService
            .getSettings()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((result) => {
                this.domainSettings = result;
                for (const [app, settings] of Object.entries(this.domainSettings.apps)) {
                    let jsonSettings = JSON.stringify(settings);
                    this.cesarApplications.push(JSON.parse(jsonSettings));
                }
            });
    }

    /**
     * Appelée à la destruction du composant.
     */
    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    /** Construit l'url avec le token si authentifié */
    getUrl(url: string) {
        if (!!this.userConnected) {
            return `${url}?__access_token__=${this.userConnected.token.accessToken}`;
        } else {
            return `${url}`;
        }
    }
}
